export const translations = {
  de: {
    nav: {
      features: 'Features',
      pricing: 'Pakete',
      comparison: 'Vergleich',
      faq: 'FAQ',
      contact: 'Anfrage',
      order: 'Jetzt bestellen',
    },
    hero: {
      overline: 'DSGVO-konform \u00b7 Hosted in Deutschland',
      title: 'E-Mail die alles kann.',
      title_lines: ['E-Mail', 'die alles', 'kann.'],
      subtitle: 'Zimbra Hosting mit Anti-Spam, Kalender, Cloud-Speicher und ActiveSync. Server in Deutschland, 99,9% Verf\u00fcgbarkeit. Ab 1,69 \u20ac/Monat.',
      cta_order: 'Pakete ansehen',
      cta_enterprise: 'Enterprise-Anfrage',
    },
    marquee: 'DSGVO SICHER \u2022 HOSTED IN GERMANY \u2022 99,9% UPTIME \u2022 ANTI-SPAM \u2022 ANTI-VIRUS \u2022 ACTIVESYNC \u2022 CLOUD SPEICHER \u2022',
    features: {
      overline: 'FEATURES',
      title: 'Mehr als nur E-Mail',
      subtitle: 'Zimbra vereint alles, was moderne Kommunikation braucht \u2013 in einer einzigen Plattform.',
      items: {
        antispam: { title: 'Anti-Virus & Anti-Spam', desc: 'KI-gest\u00fctzte Abwehr gegen Spam, Viren, Malware und Phishing. Dein Posteingang bleibt sauber.' },
        sync: { title: '\u00dcberall arbeiten', desc: 'Webmail, Desktop oder Mobil \u2013 Zimbra synchronisiert alle Ger\u00e4te nahtlos \u00fcber ActiveSync.' },
        cloud: { title: 'Cloud-Speicher', desc: 'Speichere und teile Dokumente sicher in der Cloud. Direkt in Zimbra integriert.' },
        calendar: { title: 'Kalender & Kontakte', desc: 'Gemeinsame Kalender, Terminassistent, iCal-Support und globale Adressliste.' },
        dsgvo: { title: 'DSGVO-konform', desc: 'Server in Deutschland. Wir lesen niemals deine E-Mails. Strenge Datenschutzrichtlinien.' },
        office: { title: 'Zimbra Office', desc: 'Dokumente erstellen und bearbeiten direkt in Zimbra. Word, Excel und PowerPoint kompatibel.' },
        alias: { title: 'Verteiler & Aliase', desc: 'Unbegrenzte Domain-Aliase und Verteilerlisten. Professionelle Kommunikation.' },
        uptime: { title: '99,9% Verf\u00fcgbarkeit', desc: 'SLA-garantierte Verf\u00fcgbarkeit. Redundante Infrastruktur im deutschen Rechenzentrum.' },
        email: { title: 'Alle E-Mail Features', desc: 'Weiterleitungen, Aliase, Auto-Responder, Filter, Signaturen und Benachrichtigungen.' },
        s_mime: { title: 'S/MIME Verschl\u00fcsselung', desc: 'Ende-zu-Ende verschl\u00fcsselte E-Mails f\u00fcr maximale Sicherheit. In Zimbra Pro enthalten.' },
        twofa: { title: 'Zwei-Faktor-Auth', desc: 'Zus\u00e4tzliche Sicherheitsebene mit 2FA. Sch\u00fctze dein Konto vor unbefugtem Zugriff.' },
        mobile: { title: 'Mobile Richtlinien', desc: 'Verwalte mobile Ger\u00e4te zentral. Remote-Wipe, PIN-Richtlinien und Ger\u00e4teverwaltung.' },
      }
    },
    pricing: {
      overline: 'PAKETE',
      title: 'W\u00e4hle dein Zimbra Paket',
      subtitle: 'Von Einzelnutzer bis Enterprise \u2013 f\u00fcr jeden Bedarf das richtige Paket.',
      monthly: '/Mo.',
      cta: 'Jetzt konfigurieren',
      recommended: 'Empfohlen',
      basic: {
        name: 'Zimbra Basic',
        price: '1,69',
        desc: '1 Postfach, 1 GB Speicher',
        features: ['Ab 1 Postfach', 'Ab 1 GB Speicher', 'POP3/IMAP', 'Anti-Spam', 'Webmail', 'DSGVO-konform'],
      },
      plus: {
        name: 'Zimbra Plus',
        price: '9,98',
        desc: '5 Postf\u00e4cher, 10 GB Speicher, Cloud',
        features: ['Ab 5 Postf\u00e4cher', 'Ab 10 GB Speicher', 'Cloud-Speicher', 'Kalender & Kontakte', 'CardDAV/CalDAV', 'Zimbra Office'],
      },
      pro: {
        name: 'Zimbra Pro',
        price: '24,99',
        desc: '10 Postf\u00e4cher, 25 GB Speicher, ActiveSync',
        features: ['Ab 10 Postf\u00e4cher', 'Ab 25 GB Speicher', 'ActiveSync', 'S/MIME', 'Zwei-Faktor-Auth', 'Mobile Richtlinien'],
      },
    },
    comparison: {
      overline: 'VERGLEICH',
      title: 'Warum Zimbra?',
      subtitle: 'So schl\u00e4gt sich Zimbra gegen die bekannten Alternativen.',
      zimbra: 'Zimbra',
      headers: {
        feature: 'Feature',
        dsgvo: 'DSGVO-konform',
        server_de: 'Server in DE',
        activesync: 'ActiveSync',
        calendar: 'Kalender',
        cloud: 'Cloud-Speicher',
        office: 'Office Suite',
        antispam: 'Anti-Spam',
        smime: 'S/MIME',
        price: 'Preis ab',
        open_source: 'Open Source',
      },
      zimbra_vals: { dsgvo: true, server_de: true, activesync: true, calendar: true, cloud: true, office: true, antispam: true, smime: true, price: '1,69\u20ac', open_source: true },
      gmail_vals: { dsgvo: false, server_de: false, activesync: false, calendar: true, cloud: true, office: true, antispam: true, smime: false, price: '5,75\u20ac', open_source: false },
      outlook_vals: { dsgvo: false, server_de: false, activesync: true, calendar: true, cloud: true, office: true, antispam: true, smime: true, price: '5,60\u20ac', open_source: false },
    },
    enterprise: {
      overline: 'ENTERPRISE',
      title: 'Mehr Bedarf?',
      subtitle: 'Individuelle L\u00f6sungen f\u00fcr Unternehmen und Institutionen. Stellen Sie jetzt Ihre Anfrage.',
      fields: {
        company: 'Firmenname',
        contact: 'Ansprechpartner',
        email: 'E-Mail',
        phone: 'Telefon',
        mailboxes: 'Anzahl Postf\u00e4cher',
        package: 'Gew\u00fcnschtes Paket',
        message: 'Nachricht',
        select_package: 'Paket w\u00e4hlen',
      },
      cta: 'Anfrage senden',
      success: 'Ihre Anfrage wurde erfolgreich gesendet!',
      error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
    faq: {
      overline: 'FAQ',
      title: 'H\u00e4ufig gestellte Fragen',
      items: [
        { q: 'Was ist Zimbra?', a: 'Zimbra ist eine professionelle E-Mail- und Collaboration-Plattform. Sie bietet E-Mail, Kalender, Kontakte, Aufgaben, Cloud-Speicher und ein integriertes Office \u2013 alles in einem. Zimbra ist Open Source und wird weltweit von Millionen Nutzern eingesetzt.' },
        { q: 'Kann ich meine bestehenden E-Mails migrieren?', a: 'Ja! Host-On bietet kostenlose Migration von bestehenden E-Mail-Accounts. Egal ob von Gmail, Outlook, Exchange oder einem anderen Anbieter \u2013 wir migrieren Ihre E-Mails, Kontakte und Kalender.' },
        { q: 'Funktioniert Zimbra mit Outlook?', a: 'Ja, Zimbra ist vollst\u00e4ndig kompatibel mit Microsoft Outlook \u00fcber ActiveSync (Pro-Paket) oder IMAP/POP3. Auch Apple Mail, Thunderbird und andere E-Mail-Clients werden unterst\u00fctzt.' },
        { q: 'Wie sicher sind meine Daten?', a: 'Ihre Daten werden ausschlie\u00dflich auf Servern in Deutschland gehostet. Host-On liest niemals Ihre E-Mails. Alle Verbindungen sind SSL/TLS-verschl\u00fcsselt. Im Pro-Paket zus\u00e4tzlich S/MIME und 2FA verf\u00fcgbar.' },
        { q: 'Was ist der Unterschied zwischen den Paketen?', a: 'Basic bietet E-Mail-Grundfunktionen mit POP3/IMAP. Plus enth\u00e4lt zus\u00e4tzlich Cloud-Speicher, Kalender, CardDAV/CalDAV und Zimbra Office. Pro bietet dar\u00fcber hinaus ActiveSync, S/MIME-Verschl\u00fcsselung, 2FA und mobile Ger\u00e4teverwaltung.' },
        { q: 'Gibt es eine Mindestvertragslaufzeit?', a: 'Nein, alle Zimbra-Pakete bei Host-On sind monatlich k\u00fcndbar. Keine versteckten Kosten, keine langfristigen Bindungen.' },
        { q: 'Ist Zimbra DSGVO-konform?', a: 'Ja, zu 100%. Alle Server stehen in Deutschland, es findet kein Datentransfer in Drittl\u00e4nder statt. Host-On erf\u00fcllt alle Anforderungen der DSGVO und unterliegt deutschem Datenschutzrecht.' },
        { q: 'Kann ich eigene Domains verwenden?', a: 'Selbstverst\u00e4ndlich. Sie k\u00f6nnen beliebig viele eigene Domains einbinden und unbegrenzt Domain-Aliase erstellen.' },
      ]
    },
    footer: {
      powered: 'Ein Produkt von',
      privacy: 'Datenschutz',
      imprint: 'Impressum',
      rights: 'Alle Rechte vorbehalten.',
    }
  },
  en: {
    nav: {
      features: 'Features',
      pricing: 'Packages',
      comparison: 'Compare',
      faq: 'FAQ',
      contact: 'Contact',
      order: 'Order now',
    },
    hero: {
      overline: 'GDPR compliant \u00b7 Hosted in Germany',
      title: 'Email that does it all.',
      title_lines: ['Email', 'that does', 'it all.'],
      subtitle: 'Zimbra Hosting with anti-spam, calendar, cloud storage and ActiveSync. Servers in Germany, 99.9% availability. Starting at \u20ac1.69/month.',
      cta_order: 'View packages',
      cta_enterprise: 'Enterprise inquiry',
    },
    marquee: 'GDPR SECURE \u2022 HOSTED IN GERMANY \u2022 99.9% UPTIME \u2022 ANTI-SPAM \u2022 ANTI-VIRUS \u2022 ACTIVESYNC \u2022 CLOUD STORAGE \u2022',
    features: {
      overline: 'FEATURES',
      title: 'More than just email',
      subtitle: 'Zimbra combines everything modern communication needs \u2013 in one platform.',
      items: {
        antispam: { title: 'Anti-Virus & Anti-Spam', desc: 'AI-powered defense against spam, viruses, malware and phishing. Your inbox stays clean.' },
        sync: { title: 'Work anywhere', desc: 'Webmail, desktop or mobile \u2013 Zimbra syncs all devices seamlessly via ActiveSync.' },
        cloud: { title: 'Cloud Storage', desc: 'Store and share documents securely in the cloud. Directly integrated into Zimbra.' },
        calendar: { title: 'Calendar & Contacts', desc: 'Shared calendars, scheduling assistant, iCal support and global address list.' },
        dsgvo: { title: 'GDPR compliant', desc: 'Servers in Germany. We never read your emails. Strict privacy policies.' },
        office: { title: 'Zimbra Office', desc: 'Create and edit documents directly in Zimbra. Word, Excel and PowerPoint compatible.' },
        alias: { title: 'Lists & Aliases', desc: 'Unlimited domain aliases and distribution lists. Professional communication.' },
        uptime: { title: '99.9% Uptime', desc: 'SLA-guaranteed availability. Redundant infrastructure in German data center.' },
        email: { title: 'All Email Features', desc: 'Forwarding, aliases, auto-responders, filters, signatures and notifications.' },
        s_mime: { title: 'S/MIME Encryption', desc: 'End-to-end encrypted emails for maximum security. Included in Zimbra Pro.' },
        twofa: { title: 'Two-Factor Auth', desc: 'Additional security layer with 2FA. Protect your account from unauthorized access.' },
        mobile: { title: 'Mobile Policies', desc: 'Manage mobile devices centrally. Remote wipe, PIN policies and device management.' },
      }
    },
    pricing: {
      overline: 'PACKAGES',
      title: 'Choose your Zimbra package',
      subtitle: 'From single user to enterprise \u2013 the right package for every need.',
      monthly: '/mo.',
      cta: 'Configure now',
      recommended: 'Recommended',
      basic: {
        name: 'Zimbra Basic',
        price: '1.69',
        desc: '1 mailbox, 1 GB storage',
        features: ['From 1 mailbox', 'From 1 GB storage', 'POP3/IMAP', 'Anti-spam', 'Webmail', 'GDPR compliant'],
      },
      plus: {
        name: 'Zimbra Plus',
        price: '9.98',
        desc: '5 mailboxes, 10 GB storage, Cloud',
        features: ['From 5 mailboxes', 'From 10 GB storage', 'Cloud storage', 'Calendar & Contacts', 'CardDAV/CalDAV', 'Zimbra Office'],
      },
      pro: {
        name: 'Zimbra Pro',
        price: '24.99',
        desc: '10 mailboxes, 25 GB storage, ActiveSync',
        features: ['From 10 mailboxes', 'From 25 GB storage', 'ActiveSync', 'S/MIME', 'Two-Factor Auth', 'Mobile policies'],
      },
    },
    comparison: {
      overline: 'COMPARISON',
      title: 'Why Zimbra?',
      subtitle: 'How Zimbra compares to the well-known alternatives.',
      zimbra: 'Zimbra',
      headers: {
        feature: 'Feature',
        dsgvo: 'GDPR compliant',
        server_de: 'Servers in DE',
        activesync: 'ActiveSync',
        calendar: 'Calendar',
        cloud: 'Cloud storage',
        office: 'Office Suite',
        antispam: 'Anti-Spam',
        smime: 'S/MIME',
        price: 'Price from',
        open_source: 'Open Source',
      },
      zimbra_vals: { dsgvo: true, server_de: true, activesync: true, calendar: true, cloud: true, office: true, antispam: true, smime: true, price: '\u20ac1.69', open_source: true },
      gmail_vals: { dsgvo: false, server_de: false, activesync: false, calendar: true, cloud: true, office: true, antispam: true, smime: false, price: '\u20ac5.75', open_source: false },
      outlook_vals: { dsgvo: false, server_de: false, activesync: true, calendar: true, cloud: true, office: true, antispam: true, smime: true, price: '\u20ac5.60', open_source: false },
    },
    enterprise: {
      overline: 'ENTERPRISE',
      title: 'Need more?',
      subtitle: 'Custom solutions for businesses and institutions. Submit your inquiry now.',
      fields: {
        company: 'Company name',
        contact: 'Contact person',
        email: 'Email',
        phone: 'Phone',
        mailboxes: 'Number of mailboxes',
        package: 'Desired package',
        message: 'Message',
        select_package: 'Select package',
      },
      cta: 'Send inquiry',
      success: 'Your inquiry was sent successfully!',
      error: 'Error sending. Please try again.',
    },
    faq: {
      overline: 'FAQ',
      title: 'Frequently Asked Questions',
      items: [
        { q: 'What is Zimbra?', a: 'Zimbra is a professional email and collaboration platform. It offers email, calendar, contacts, tasks, cloud storage and an integrated office suite \u2013 all in one. Zimbra is open source and used by millions worldwide.' },
        { q: 'Can I migrate my existing emails?', a: 'Yes! Host-On offers free migration from existing email accounts. Whether from Gmail, Outlook, Exchange or another provider \u2013 we migrate your emails, contacts and calendars.' },
        { q: 'Does Zimbra work with Outlook?', a: 'Yes, Zimbra is fully compatible with Microsoft Outlook via ActiveSync (Pro package) or IMAP/POP3. Apple Mail, Thunderbird and other email clients are also supported.' },
        { q: 'How secure is my data?', a: 'Your data is hosted exclusively on servers in Germany. Host-On never reads your emails. All connections are SSL/TLS encrypted. Pro package additionally offers S/MIME and 2FA.' },
        { q: 'What is the difference between packages?', a: 'Basic offers email basics with POP3/IMAP. Plus additionally includes cloud storage, calendar, CardDAV/CalDAV and Zimbra Office. Pro also offers ActiveSync, S/MIME encryption, 2FA and mobile device management.' },
        { q: 'Is there a minimum contract period?', a: 'No, all Zimbra packages at Host-On are cancelable monthly. No hidden costs, no long-term commitments.' },
        { q: 'Is Zimbra GDPR compliant?', a: 'Yes, 100%. All servers are located in Germany, there is no data transfer to third countries. Host-On meets all GDPR requirements and is subject to German data protection law.' },
        { q: 'Can I use my own domains?', a: 'Of course. You can add as many custom domains as you want and create unlimited domain aliases.' },
      ]
    },
    footer: {
      powered: 'A product by',
      privacy: 'Privacy',
      imprint: 'Imprint',
      rights: 'All rights reserved.',
    }
  }
};
